import { render, staticRenderFns } from "./veterinaryRecommendation.vue?vue&type=template&id=12822723"
import script from "./veterinaryRecommendation.vue?vue&type=script&lang=js"
export * from "./veterinaryRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports